/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent, CardExtra } from '../../Shared/Card'
import { Icon, Statistic, StatisticLabel, StatisticValue } from 'semantic-ui-react'
import { Link } from 'react-router-dom-v5-compat'
import { useQuery } from '@tanstack/react-query'
import { getMetricsOrders } from '../../../../services/Metrics/Metrics.service'
import { formatISO, startOfDay, roundToNearestMinutes } from 'date-fns'
import useUser from '../../../Shared/UserProvider/useUser'
import { isProviderAPos } from '../../../../services/Provider/Provider.service'
import { getCancellationSource } from '../../../../services/http-client'
import { intlFormat } from '../../../../helpers/money'
import { CardLoadingPlaceholder } from '../../Shared/CardLoadingPlaceholder'

const PositiveActivityCard = () => {
    const from = formatISO(startOfDay(new Date()))
    const to = formatISO(roundToNearestMinutes(new Date(), { nearestTo: 5, roundingMethod: 'floor' }))

    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['positive-metrics', from, to],
        queryFn: async () => await getMetricsOrders({
            dateRange: {
                startDate: from,
                endDate: to,
            },
            merchantId: isProviderAPos(user.provider) ? user.provider.object.id : null,
            brandIds: [],
            platformIds: [],
            dateComparison: null,
        }, getCancellationSource()),
    })

    const metrics = data?.byDate[0]
    const nbOrder = metrics?.nborder || 0
    const revenues = metrics?.revenues || 0
    const averageOrder = metrics?.avgorder || 0

    return (
      <Card>
          <CardContent
            css={css`
                display: grid;
                place-items: center;
                gap: .5rem;
                grid-template-areas: ${isLoading ? `'a'` : `'a a' 'c d'`};
                width: 283px;
                height: 175px;
            `}
          >
              {isLoading ? (
                <CardLoadingPlaceholder
                  css={css`
                      grid-area: a;
                  `}
                />
              ) : (
                <>
                    <Statistic
                      css={css`
                          grid-area: a;
                          &.ui.statistic, &.ui.statistic + .ui.statistic {
                              margin: 0;
                          }
                      `}
                      color="teal"
                    >
                        <StatisticValue>
                            {intlFormat(revenues, user.getCompanyCurrency(), user.getCompanyLocale())}
                        </StatisticValue>
                        <StatisticLabel>
                            Chiffre d'affaire
                        </StatisticLabel>
                    </Statistic>

                    <Statistic
                      css={css`
                          grid-area: c;

                          &.ui.statistic + .ui.statistic {
                              margin: 0;
                          }
                      `}
                      size="tiny"
                      color="teal"
                    >
                        <StatisticValue>
                            {nbOrder}
                        </StatisticValue>
                        <StatisticLabel>
                            #Commandes
                        </StatisticLabel>
                    </Statistic>

                    <Statistic
                      css={css`
                          grid-area: d;
                      `}
                      size="tiny"
                      color="teal"
                    >
                        <StatisticValue>
                            {intlFormat(averageOrder, user.getCompanyCurrency(), user.getCompanyLocale())}
                        </StatisticValue>
                        <StatisticLabel>
                            Commande moyenne
                        </StatisticLabel>
                    </Statistic>
                </>
              )}
          </CardContent>

          <CardExtra>
              <Link
                to={{
                    pathname: '/analytics',
                }}>
                  CA
                  <Icon name="arrow right"/>
              </Link>
          </CardExtra>
      </Card>
    )
}

export { PositiveActivityCard }
